export default __webpack_public_path__ + "static/media/dots.298ece9d.png";